<template>
  <div class="about">
    <div class="bg-white-900 mb-14 mt-10">
      <div class="container mx-auto">
        <h1 class="sr-only">Publishers list</h1>
        <!-- catalog info block -->
        <actions-bar
          title="Publishers"
          title-class="text-5xl"
          placeholder="Search by name"
          select-type="publishers"
        />
        <card-publisher-summary
          v-for="publisher in publishers"
          :key="publisher.id"
          :publisher-data="publisher"
          class="mb-3"
          @open-book-modal="openBookModal"
        />
        <base-button class="mt-6">
          <svg
            class="mr-2"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 1V11M11 6L1 6"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
          Show more 24
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import CardPublisherSummary from "@/components/cards/CardPublisherSummary.vue";
import ActionsBar from "@/components/base/ActionsBar.vue";

export default {
  name: "Publishers",
  components: {
    "actions-bar": ActionsBar,
    "card-publisher-summary": CardPublisherSummary,
    "base-button": () => import("@/components/utils/Button.vue"),
  },
  data() {
    return {
      publishers: [
        {
          id: 1,
          name: "Ethos Books",
          imageURl: require("@/assets/publishers/1.png"),
          publisherCatalogs: 15,
          publisherBooks: 15,
          publisherCatalogsArray: [
            {
              id: 1,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/1.jpg"),
              catalogTitles: 24,
            },
            {
              id: 2,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/2.jpg"),
              catalogTitles: 24,
            },
            {
              id: 3,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/3.jpg"),
              catalogTitles: 24,
            },
            {
              id: 4,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/4.jpg"),
              catalogTitles: 24,
            },
            {
              id: 5,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/5.jpg"),
              catalogTitles: 24,
            },
          ],
          publisherBooksArray: [
            {
              id: 1,
              name: "Book Name",
              imageURl: require("@/assets/books/1.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 2,
              name: "Book Name",
              imageURl: require("@/assets/books/2.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 3,
              name: "Book Name",
              imageURl: require("@/assets/books/3.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 4,
              name: "Book Name",
              imageURl: require("@/assets/books/4.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 5,
              name: "Book Name",
              imageURl: require("@/assets/books/5.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
          ],
        },
        {
          id: 2,
          name: "Ethos Books",
          imageURl: require("@/assets/publishers/2.png"),
          publisherCatalogs: 15,
          publisherBooks: 15,
          publisherCatalogsArray: [
            {
              id: 1,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/6.jpg"),
              catalogTitles: 24,
            },
            {
              id: 2,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/7.jpg"),
              catalogTitles: 24,
            },
            {
              id: 3,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/8.jpg"),
              catalogTitles: 24,
            },
            {
              id: 4,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/9.jpg"),
              catalogTitles: 24,
            },
            {
              id: 5,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/10.jpg"),
              catalogTitles: 24,
            },
          ],
          publisherBooksArray: [
            {
              id: 1,
              name: "Book Name",
              imageURl: require("@/assets/books/6.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 2,
              name: "Book Name",
              imageURl: require("@/assets/books/7.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 3,
              name: "Book Name",
              imageURl: require("@/assets/books/8.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 4,
              name: "Book Name",
              imageURl: require("@/assets/books/9.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 5,
              name: "Book Name",
              imageURl: require("@/assets/books/10.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
          ],
        },
        {
          id: 3,
          name: "Ethos Books",
          imageURl: require("@/assets/publishers/3.png"),
          publisherCatalogs: 15,
          publisherBooks: 15,
          publisherCatalogsArray: [
            {
              id: 1,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/11.jpg"),
              catalogTitles: 24,
            },
            {
              id: 2,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/12.jpg"),
              catalogTitles: 24,
            },
            {
              id: 3,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/13.jpg"),
              catalogTitles: 24,
            },
            {
              id: 4,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/14.jpg"),
              catalogTitles: 24,
            },
            {
              id: 5,
              name: "Catalog Name",
              imageURl: require("@/assets/new-catalogs/15.jpg"),
              catalogTitles: 24,
            },
          ],
          publisherBooksArray: [
            {
              id: 1,
              name: "Book Name",
              imageURl: require("@/assets/books/11.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 2,
              name: "Book Name",
              imageURl: require("@/assets/books/12.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 3,
              name: "Book Name",
              imageURl: require("@/assets/books/13.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 4,
              name: "Book Name",
              imageURl: require("@/assets/books/14.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
            {
              id: 5,
              name: "Book Name",
              imageURl: require("@/assets/books/15.jpg"),
              author:
                "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), CHRISTINE CHIA (ED.)",
            },
          ],
        },
      ],
    };
  },
  methods: {
    openBookModal(bookData) {
      this.$modal.show("book-modal", { ...bookData });
    },
  },
};
</script>
